// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_p2-0";
export var buttonContainer = "_p2-3";
export var cancelButton = "_p2-4";
export var headerSection = "_p2-6";
export var headerTitle = "_p2-9";
export var messageSideLeft = "_p2-1";
export var messageSideRight = "_p2-2";
export var orderNumberContainer = "_p2-7";
export var orderNumberLabel = "_p2-8";
export var submitButton = "_p2-5";